module.exports = __webpack_public_path__ + "fonts/sourcesanspro-extralight-webfont.df24c4d1.woff2";